import React from 'react';
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { AppConfig } from "./config/appConfig";

const BASENAME = AppConfig.BASENAME;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename={BASENAME}>
    <App />
  </BrowserRouter>
);
